// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1uOdY","productName":"Table_productName__2D2PD"};